import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, translate } from "../../utils/useful";
import { getBoundingClientRect } from "../../utils/functions";

class SelectInput extends React.Component {
    constructor(props) {
        super(props);
        this.endOfListRef = React.createRef();
        this.openedRect = React.createRef();
        this.debouncedSearch = this.debounce(this.fetch, 700);
        const headerLimit = Number(props.header?.information?.limit)
        this.state = {
            options: [],
            isLoading: false,
            limit: Number.isFinite(headerLimit) && headerLimit > 0 ? headerLimit : 20,
            page: 0,
            tempData: [],
            searchPage: 0,
            isSearching: false
        }
    }
 // Debounce function
 debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
    componentDidMount() {
        this.init(true)
    }


    componentDidUpdate(prevProps) {

        // console.log("componentDidUpdate",this.props.header)
        // console.log(this.props.header.key,this.props.data)
        if (prevProps.data != this.props.data) {
            // console.log('filllllllllterrrrrrrrrrrrrrrrzzzzzzzzzzz');
            this.init()
        }

        if (this.state.options != this.props.header.information.items && this.props.header.information.type === "local") {
            this.setState({ options: this.props.header.information.items })
        }
    }

    init(mount) {
        // console.log('filllllllllterrrrrrrrrrrrrrrrzzzzzzzzzzzinit');


        // if(!mount){
        //     this.props.changeValue(this.props.header.key, null, this.props.extra) 
        // }
        if (this.props.header.information) {
            if (this.props.header.information.type === "local") {

                let choosen

                if (this.props.data || this.props.data == '0' && Array.isArray(this.props.header.information.items)) {
                    this.props.header.information.items.forEach(element => {

                        if (element.value == this.props.data || (element.value2 && element.value2 == this.props.data)) {
                            choosen = element
                        }
                    });
                }

                this.setState({ options: this.props.header.information.items, choosen })
            } else if (this.props.header.information.type === "api") {
                this.fetch(mount)
            }
        }

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        if (!this.state.isOpen && this.state.options.length < this.state.limit&& !this.state.isSearching && this.props.header.information.type === "api") {

            this.fetch()
        }
        if (openState) {
            document.addEventListener('mousedown', this.closeBox);
            window.addEventListener('scroll', this.getPosition, true);

            // window.addEventListener('scroll', this.handleScroll,true)
            this.getPosition()

        } else {
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);
            // window.removeEventListener('scroll', this.handleScroll);
        }
        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
        if (this.endOfListRef.current) {
            const openedRect = getBoundingClientRect(this.openedRect.current);
            this.setState({ openedRect })
            const { top } = this.endOfListRef.current.getBoundingClientRect();

            // console.log('filllllllllterrrrrrrrrrrrrrrr',openedRect.bottom,top);
            if (top - 0.001 <= (openedRect.bottom)) {
                // console.log('filllllllllterrrrrrrrrrrrrrrr1111111111', this.state.maxPage);

                if (this.state.page < this.state.maxPage && this.props.header.information.type === "api" && (!this.state.isSearching || (this.state.isSearching  && this.state.searchPage < this.state.maxSearchPage) )) {

                    this.fetch();
                }
            }
        }
    }


    changeItem = (prop, selected, dontChangeValue) => {

        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        choosen = prop

        this.setState({ choosen }, () => {
            this.changeValue()
        })

        setTimeout(() => {
            this.toggleOpen(true)
        }, 1);


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })


    }


    fetch(init, text, isSearching) {

        if(init && !this.props.data && !(isSearching || this.state.isSearching)){
            return
        }
        if(init){
            this.setState({
                options: [],

                tempData: [],
                prevData: [],
                maxPage:null
              
            }, () => {
          
            })
        }
        // if(!isSearching && this.state.text){
        //     return
        // }
        if (isSearching && !text) {
            this.setState({
                options: this.state.tempData,
                searchPage:0,
                maxSearchPage:null,
                isSearching:false
            }, () => {

            })
        } else {

            if (!init) {
                this.setState({ isLoadingInside: true })
            } else {
                this.setState({ isLoading: true })
            }
            window.removeEventListener('scroll', this.getPosition, true);
            // console.log(this.props.header.information.filter)
            let filter = JSON.parse(JSON.stringify(this.props.header.information.filter))
            if (this.props.header.information.sort) {
                filter.sort = this.props.header.information.sort
            }

            for (const [key, value] of Object.entries(filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                    // console.log("VAR")
                }
            }
            if (text) {
                filter.skip = 0
                filter.limit = this.state.limit
                filter.getCount = true
                if (!filter.filter2) {
                    filter.filter2 = {}
                }

                filter.filter2[this.props.header.information.fields.title] = {
                    key: this.props.header.information.fields.title,
                    value: text,
                    operator: 'contains',
                    type: 'SelectInput',
                    label: this.props.header.information.fields.title
                }
                // if (this.props.header.information.fields.description) {
                //     filter.filter2[this.props.header.information.fields.description] = {
                //         key: this.props.header.information.fields.description,
                //         value: text,
                //         operator: 'contains',
                //         type: 'SelectInput',
                //         label: this.props.header.information.fields.description
                //     }

                // }
            } else  if(this.state.isSearching  && this.state.maxSearchPage) {
                filter.skip = this.state.searchPage
                filter.limit = this.state.limit
                if (!filter.filter2) {
                    filter.filter2 = {}
                }

                filter.filter2[this.props.header.information.fields.title] = {
                    key: this.props.header.information.fields.title,
                    value: this.state.text,
                    operator: 'contains',
                    type: 'SelectInput',
                    label: this.props.header.information.fields.title
                }
            }
            if (filter.filter) {
                for (const [key, value] of Object.entries(filter.filter)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            filter.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                        // console.log("VAR")
                    }
                }
                if (this.props.data && init && !isSearching) {

                    filter.filter[this.props.header?.information?.fields?.value] = this.props.data[this.props.header?.information?.fields?.value] ?? this.props.data
                }
            } else {
                if (this.props.data && init && !isSearching) {
                    filter.filter = { [this.props.header?.information?.fields?.value] : this.props.data[this.props.header?.information?.fields?.value] ?? this.props.data }
                }
            }
           
            if (!init && !this.state.maxSearchPage ) {

                filter.limit = this.state.limit
                filter.skip = this.state.page
                if (!this.state.maxPage) {
                    filter.getCount = true
                }
            }
            // else if(!init && this.state.maxSearchPage){
            //     filter.limit = this.state.limit
            //     filter.skip = this.state.searchPage

            // }
            // console.log('filllllllllterrrrrrrrrrrrrrrr',this.props.header.information.address, filter)
            // console.log(this.props.variables)
if(filter.country){
    filter.country = filter.country._id ?? filter.country
}else if(!filter.country && !filter.filter?.country && !filter.filter2?.country){
    filter.NoCountry = true
}
HttpService.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {
                if (fetchError) {
                    this.setState({ isLoading: false, isLoadingInside: false })
                    return
                }
                if (!fetchResult || fetchResult.info == null) {
                    this.setState({ isLoading: false, isLoadingInside: false })
                    return
                }

                var prevData = JSON.parse(JSON.stringify(this.state.options))
                var newData = (this.state.options.length > 1 || fetchResult.info.length < 2 ) ? this.state.options : []
                if (isSearching) (
                    newData = []
                )
                if (!this.state.maxPage && !init) {
                    if (fetchResult.count) {
                        this.setState({ maxPage: Math.ceil(fetchResult.count / this.state.limit) },()=>{
                            // console.log('filllllllllterrrrrrrrrrrrrrrr', this.state.maxPage)

                        })
                    }
                }
                if(text){
                    
                    this.setState({maxSearchPage : Math.ceil(fetchResult.count / this.state.limit)})
                }else{

                    
                    if (!init) {
                        this.setState({ page: this.state.page + 1 })
                        
                    } else {
                        this.setState({ page: 0 })
                        
                    }
                }
                if(this.state.maxSearchPage || text){
                    this.setState({searchPage:this.state.searchPage + 1})
                }
                if (this.props.header.key == 'country') {
                    fetchResult.info.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    })
                    fetchResult.info.sort((a, b) => {
                        if (a.priority < b.priority) {
                            return -1;
                        }
                        if (a.priority > b.priority) {
                            return 1;
                        }
                        return 0;
                    })
                }
                fetchResult.info.forEach(element => {

                    var newDesc

                    var newTitle = this.spliter(element, this.props.header.information.fields.title)
                    var newValue = this.spliter(element, this.props.header.information.fields.value)

                    // console.log(this.props.header.key)
                    // console.log(this.props.header.information.fields.description)

                    if (this.props.header.information.fields.description) {
                        newDesc = this.spliter(element, this.props.header.information.fields.description)
                    }
                    // console.log(newTitle)
                    // console.log(newDesc)


                    newData.push({ value: newValue, title: newTitle, description: newDesc })
                    prevData.push({ value: newValue, title: newTitle, description: newDesc })
                });
                // console.log("NEW DATA")
                // console.log(newData)
                // setTimeout(() => {
                // console.log(this.props.data)

                if (this.props.data != null && !this.state.choosen) {
                    let found = false
                    // console.log(this.props.data)
                    let dataKey = typeof this.props.data == 'object' ? this.props.data._id : this.props.data

                    //   console.log(dataKey)
                    prevData.forEach(element => {
                        // console.log(element.value)
                        // console.log(element.value )

                        if (element.value == dataKey) {
                            // console.log("FOUND")
                            found = true
                        }

                    });

                    if (found == false) {
                        // console.log("DWLKFJWLK")
                        // this.props.changeValue(this.props.header.key, null, this.props.extra)
                    }

                }

                if (this.props.data && !this.state.choosen) {
                    let choosen
                    // this.props.data.forEach(oneTitle => {
                    let oneTitle = this.props.data
                    let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                    prevData.forEach(oneNewData => {

                        if (oneNewData.value == oneTitleId) {
                            choosen = { title: oneNewData.title, value: oneTitleId, description: oneNewData.description }
                        }
                    });

                    // })

                    // console.log(choosen)

                    this.setState({ choosen })


                } else if (!this.state.choosen) {
                    this.changeItem(null, null)

                }
                let tempData = this.state.tempData
                if (!(isSearching || this.state.isSearching)) {
                    tempData = newData
                }


                this.setState({
                    options: newData,
                    tempData: tempData,
                    prevData: prevData,
                    isLoading: false,
                    isLoadingInside: false,
                }, () => {
                    setTimeout(() => {
                        window.addEventListener('scroll', this.getPosition, true)
                    }, 500);
                })
                // }, 1000);


            })


        }
    }

    // handleScroll = () => {
    //     console.log('kooooooooooooooooooooooooooooo',this.endOfListRef,this.endOfListRef.current);
    //     if (this.endOfListRef.current) {
    //         const { top } = this.endOfListRef.current.getBoundingClientRect();
    //         const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    //         // console.log('kooooooooooooooooooooooooooooo',top,windowHeight,this.state.maxPage);
    //         if (top <= windowHeight) {
    //             if (this.state.page <this.state.maxPage) {

    //                 this.fetch();
    //             }
    //         }
    //     }

    // };
    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }


    changeValue = (e) => {
        // console.log(e.target.value)
        let value = this.state.choosen?.value
        if (value === '') {
            value = null
        }
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }



    search = async (init, value, isSearching) => {
    this.setState({text:value,isSearching:true},async()=>{
        if (this.props.header.information.type === "api") {
            // this.fetch(init, value, isSearching)
            this.debouncedSearch(init, value, isSearching);
        } else {
            // console.log('filllllllllterrrrrrrrrrrrrrrr', value)

            this.setState({ title: value })
            if (!this.state.isOpen) {
                this.toggleOpen()
            }

            if (value == "") {
                await this.setState({ options: this.state.tempData })
                await this.setState({ tempData: [] })
            } else {
                if (this.state.tempData.length == 0) {
                    await this.setState({ tempData: this.state.options })
                }
                var values = []
                // var values = this.props.data.filter((e) => e.title === value)
                // console.log(this.state.tempData)
                // console.log('filllllllllterrrrrrrrrrrrrrrr', this.state.tempData)
                this.state.tempData.forEach(element => {
                    // console.log('filllllllllterrrrrrrrrrrrrrrr', String(element.title).toLowerCase().includes(String(value).toLowerCase()) || String(element.description).toLowerCase().includes(String(value).toLowerCase()))
                    if (String(element.title).toLowerCase().includes(String(value).toLowerCase()) || String(element.description).toLowerCase().includes(String(value).toLowerCase())) {
                        values.push(element)
                    }
                })
                // console.log(values)
                // console.log('filllllllllterrrrrrrrrrrrrrrr', values)
                
                this.setState({ options: values })
                
                // }
            }
        }
    })
    }



    render() {
        let dataValue = ''
        if (this.props.data != null) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }


        return (
            <div ref={ref => this.setWrapperRef(ref)} className='w-100' style={{ position: 'relative', height: 30 }}>
                <div className="w-100 h-100" style={{ position: 'relative' }} onClick={() => this.toggleOpen(true)} >
                    {/* <select value={dataValue} disabled={this.props.disabled || this.props.header.information?.disabled} onChange={e => { this.changeValue(e) }} className=' form-control' style={{ WebkitAppearance: 'none', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', color: '#3b3a40', width: '100%', padding: 0 }}>
                        <option disabled={this.props.header.information.required ? true : false} hidden={this.props.header.information.required ? true : false} value={''}>Select ...</option>
                        {Array.isArray(this.state.options) && this.state.options?.map((prop, index) => {

                            return (
                                <option key={index} value={prop.value}>{prop.title}</option>
                            )
                        })}
                    </select> */}


                    {this.props.header.information.placeholder && !this.state.choosen && (
                        <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                            <label className={' mr-1 ml-1 placeholder '}>{checkTextTranslation(this.props.header.information.placeholder)}</label>
                        </div>
                    )}

                    {this.state.choosen && (
                        <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                            <label className={' mr-1 ml-1  '}>{this.state.choosen.title ?? this.state.choosen.description}</label>
                        </div>
                    )}


                    {this.conditionalSettings('showInfo', true) && (
                        <p onClick={() => { if (!this.state.isLoading) { this.props.showInfo(this.props.header.information.filter, this.props.data, this.props.settings.url, this.props.settings.page) } }} style={{ fontSize: 13, color: this.state.isLoading ? '#789' : '#007aff', marginTop: 3, cursor: 'pointer', marginLeft: 3 }}>Show information</p>
                    )}

                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: -12, right: 10 }}>
                            <Loader
                                type="Oval"
                                color="rgba(0,122,255,1)"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>




                {this.state.isOpen && (
                    <div style={{ display: 'flex', position: 'fixed', top: this.state.top, left: this.state.left, width: '100%', maxWidth: 300, zIndex: 40 }}>
                        <div ref={this.openedRect} className={'search-drop-down blur-back'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffffdd', borderColor: '#eee', borderRadius: 4, minHeight: 30, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>

                            <>
                                {( this.props.header.information.type === "api") && (
                                <input value={this.state.text} onChange={event => this.search(true, event.target.value, true)} placeholder={translate("Search ...")} style={{ fontSize: 13, alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'text-start'} />
                                )}

                                <div onClick={() => this.changeItem(null, null)} style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1, backgroundColor: '#fff' }}>
                                    <p className="px-2" style={{ margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>select ...</p>
                                </div>
                                {this.state.options.map((prop, index) => {
                                    let selected = false
                                    if (this.state.choosen && this.state.choosen.value == prop.value) {
                                        selected = true
                                    }
                                    // for (var i = 0; i < this.state.choosen?.length; i++) {

                                    //     if (prop.value == this.state.choosen[i].value)
                                    //         selected = true
                                    // }
                                    // console.log(prop)

                                    // console.log('sssssssssssssss',selected, prop.value,)
                                    return (
                                        <div key={index} onClick={() => this.changeItem(prop, selected)} style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1, backgroundColor: selected ? '#f7f7f7' : '#fff' }}>
                                            <p className="px-2" style={{ margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{prop.title ? prop.title : "[ " + prop.description + ' ]'}</p>
                                        </div>
                                    )
                                })}

                                {this.state.options.length == 0 && (
                                    <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("Found Nothing")}</p>
                                        {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                    </div>
                                )}
                                {(this.state.isLoadingInside) ? (
                                    <div style={{ position: 'absolute', bottom: 10, left: this.state.openedRect ? this.state.openedRect.width / 2 : 0 }}>
                                        <Loader
                                            type="Oval"
                                            color="rgba(0,122,255,1)"
                                            height="25"
                                            width="25"
                                        />
                                    </div>
                                ) : (

                                    <div ref={this.endOfListRef} style={{ height: '1px', visibility: 'hidden', marginTop: 30 }}></div>
                                )}
                            </>
                        </div>
                    </div>
                )
                }

            </div>
        );
    }
}

export default SelectInput;
